/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getCardEyebrowText } from "@qlik/qlik/src/lib/util/helpers";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";

const PromoCardResource = ({ data }) => {
    const { backgroundColor, additionalConfiguration, backgroundImage, cardItem, customId } = data ?? {};
    const { title, body } = cardItem ?? {};
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const eyebrowText = getCardEyebrowText(cardItem);

    return (
        <section className={`promoCardResource px-3.75 ${sectionSpacingClassName}}`} id={customId}>
            <div className="container">
                <div
                    className={`mr-18 rounded-sm bg-no-repeat bg-center ${
                        styles.bgcontainer
                    } ${sectionColorMapping.bgColor || "bg-blue"}`}
                    style={{ backgroundImage: backgroundImage ? `url(${backgroundImage?.[0]?.secure_url})` : "none" }}
                >
                    <div className="p-8 lg:px-20 lg:pt-20 lg:pb-12.5">
                        {eyebrowText && <p className="tag-1 text-white mb-5">{eyebrowText}</p>}
                        {title && (
                            <h2 className="title-3 m-auto text-left lg:text-6xl mb-5 tracking-tight10 text-white">
                                {title}
                            </h2>
                        )}
                        {body && (
                            <RichText
                                data={cardItem}
                                className={`whitespace-pre-wrap text-left ${styles.contactCard}`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PromoCardResource;
